

import { bloodRelationshipActionTypes } from '../../constants/actionTypes/ssapActionTypes';
import {
    BLOOD_RELATIONSHIP_TYPES,
    CARETAKER_NOT_CONSIDERED_RELATIONSHIP_TYPES,
    ITF_CONSIDERED_RELATIONSHIP_TYPES
} from '../../constants/ssap/hhmTypes/bloodRelationshipCodesList';

export const INITIAL_STATE = {
    dropdownOptions: [],
    loadedRelations: [],
    selfOption: {},
    loadedRelationsWholeList: [],
    codes: {
        caretakerNotConsidered: {},
        itfConsidered: {}
    }
};

export default (state = INITIAL_STATE, action = {}) => {

    const newState = {};
    
    const defaultRelation = {
        'text': 'Relationship',
        'type': 'RELATION',
        'code': 'default',
        'mirrorType': 'RELATION'
    };

    const dropdownOptions = [ defaultRelation ];

    action.bloodRelationships && action.bloodRelationships.map(br => {
        if(br.type === 'SELF') {
            newState.selfOption = br;
        }
        if(br.type !== 'SELF') {
            dropdownOptions.push(br);
        }
    });

    const getRelationByType = type => {
        const br = action.bloodRelationships && action.bloodRelationships.find(br => br.type === type);
        if(br) {
            return br.code;
        } else {
            return null;
        }
    };


    switch(action.type) {

        case bloodRelationshipActionTypes.SET_RELATIONS:
            return {
                ...state,
                ...newState,
                dropdownOptions: dropdownOptions,
                loadedRelations: [
                    defaultRelation,
                    ...action.bloodRelationships
                ],
                codes: {
                    ...state.codes,
                    [BLOOD_RELATIONSHIP_TYPES.SPOUSE]: getRelationByType(BLOOD_RELATIONSHIP_TYPES.SPOUSE),
                    caretakerNotConsidered: {
                        [CARETAKER_NOT_CONSIDERED_RELATIONSHIP_TYPES.DOMESTIC_PARTNER]: getRelationByType(CARETAKER_NOT_CONSIDERED_RELATIONSHIP_TYPES.DOMESTIC_PARTNER),
                        [CARETAKER_NOT_CONSIDERED_RELATIONSHIP_TYPES.FORMER_SPOUSE]: getRelationByType(CARETAKER_NOT_CONSIDERED_RELATIONSHIP_TYPES.FORMER_SPOUSE),
                        [CARETAKER_NOT_CONSIDERED_RELATIONSHIP_TYPES.SPOUSE]: getRelationByType(CARETAKER_NOT_CONSIDERED_RELATIONSHIP_TYPES.SPOUSE),
                    }
                }
            };
        case bloodRelationshipActionTypes.SET_RELATIONS_WHOLE_LIST:
            return {
                ...state,
                loadedRelationsWholeList: action.bloodRelationships,
                codes: {
                    ...state.codes,
                    itfConsidered: {
                        [ITF_CONSIDERED_RELATIONSHIP_TYPES.CHILD]: getRelationByType(ITF_CONSIDERED_RELATIONSHIP_TYPES.CHILD),
                        [ITF_CONSIDERED_RELATIONSHIP_TYPES.STEPCHILD]: getRelationByType(ITF_CONSIDERED_RELATIONSHIP_TYPES.STEPCHILD),
                        [ITF_CONSIDERED_RELATIONSHIP_TYPES.WARD]: getRelationByType(ITF_CONSIDERED_RELATIONSHIP_TYPES.WARD),
                        [ITF_CONSIDERED_RELATIONSHIP_TYPES.FOSTER_CHILD]: getRelationByType(ITF_CONSIDERED_RELATIONSHIP_TYPES.FOSTER_CHILD)
                    }
                }
            };

        case bloodRelationshipActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;

        default:
            return state;
    }
};
